import {
  ReportSection,
  RestoreAllDataButton,
  ThumbRatingContainer,
  WarningFooter,
} from '@/reports/index';
import { commonTypes } from '@/reports/types';
import { EmailCard } from './EmailCard';

// Email section props might change after we get the serialization
export interface EmailSectionProps {
  emailsCount: number;
  personName: string;
  emailList: commonTypes.Emails;
  permalink: string;
}

export function EmailSection({
  emailsCount,
  personName,
  emailList,
  permalink,
}: EmailSectionProps) {
  return (
    <ReportSection
      title="Possible Email Addresses"
      sectionDescription={`Email addresses  ${personName} may currently or previously have used are displayed below. Run an email report on a particular email address to search for more information.`}
      sectionId="email-section"
      hasContent={emailsCount > 0}
      personName={personName}
      FooterComponent={<WarningFooter />}
    >
      {emailList.map((email) => (
        <ThumbRatingContainer
          item={email}
          key={email.address}
          component={EmailCard}
          dataPropKey="email"
          permalink={permalink}
          cardProps={{ ownerName: personName }}
        />
      ))}
      <RestoreAllDataButton items={emailList} permalink={permalink} />
    </ReportSection>
  );
}
